import { IntlShape } from 'react-intl';

const MINUTE_MS = 60_000;
const HOUR_MS = 60 * MINUTE_MS;
const DAY_MS = 24 * HOUR_MS;

/**
 * The age of the last daily read: "2 hr. ago", "3 days ago". The real age shows, also after a
 * failed read (design social-connectors a2, state 4).
 */
export function updatedAgo(intl: IntlShape, iso: string, now: Date = new Date()): string {
  const age = Math.max(0, now.getTime() - new Date(iso).getTime());
  if (age < HOUR_MS) {
    return intl.formatRelativeTime(-Math.floor(age / MINUTE_MS), 'minute', { style: 'short' });
  }
  if (age < DAY_MS) {
    return intl.formatRelativeTime(-Math.floor(age / HOUR_MS), 'hour', { style: 'short' });
  }
  return intl.formatRelativeTime(-Math.floor(age / DAY_MS), 'day', { style: 'long' });
}
